<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">詳細情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="cantSave" @click="save">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
        <v-btn :disabled="!canSplit" @click="split">split</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                disabled
                label="D/O NO(親)"
                v-model="sa.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <date-picker
                :label="$t('app.labels.etd')"
                disabled
                v-model="sa.etd"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <date-picker
                :label="$t('app.labels.eta')"
                disabled
                v-model="sa.eta"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.loadingPort')"
                clearable
                disabled
                v-model="sa.loadingPortCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.dischargePort')"
                clearable
                disabled
                v-model="sa.dischargePortCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.transportMode')"
                clearable
                disabled
                v-model="sa.transportModeCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="フライトNO"
                v-if="sa.isAir"
                v-model="sa.volNo"
              ></v-text-field>
              <v-text-field
                disabled
                label="本船"
                v-else
                v-model="sa.shipName"
              ></v-text-field>

              <!-- <v-text-field
                :label="$t('app.labels.shipName')"
                clearable
                disabled
                v-model="sa.shipName"
              ></v-text-field>-->
            </v-flex>

            <!-- <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="予定納入場所"
                url="warehouses/kv"
                v-model="sa.forecastDeliveryWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-picker label="納入予定日時間" v-model="sa.forecastDeliveryDate"></date-picker>
            </v-flex>-->
            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="コメント"
                v-model="sa.remark"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-data-table
        :headers="headers"
        :items="sa.packages"
        :rows-per-page-items="[10]"
        class="inline-edit"
        item-key="seq"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-if="balance(props.item) > 0"
              v-model="props.selected"
            ></v-checkbox>
            <v-checkbox disabled hide-details primary v-else></v-checkbox>
          </td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>
            <v-text-field disabled v-model="props.item.flag" />
          </td>
          <td>
            <v-text-field disabled v-model="props.item.cartonStartNo" />
          </td>
          <td>
            <v-text-field disabled v-model="props.item.cartonEndNo" />
          </td>
          <td>{{ props.item.perCartonQty }}</td>
          <td>
            <v-text-field disabled v-model="props.item.totalQty" />
          </td>
          <td>{{ balance(props.item) }}</td>
          <td>{{ props.item.totalNetWeight }}</td>
          <td>{{ props.item.totalGrossWeight }}</td>
          <td>{{ props.item.totalVolume }}</td>

          <!-- <td>{{props.item.containerNo}}</td> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- *************************************************************************************** -->
    <v-card style="margin-top: 20px" v-if="orders.length > 0">
      <v-card-title>
        詳細
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card
        :key="index"
        :v-if="orders.length > 0"
        v-for="(order, index) in orders"
      >
        <v-card-title>
          枝番号 ： {{ deliveryOrder.doNo }}-{{ leftPad(index + 1, 3) }}
          <v-spacer></v-spacer>
          <v-btn @click="removeDo(index)">削除DO枝番</v-btn>
          <v-btn
            :disabled="
              itemSelected[index] &&
                (itemSelected[index].length == 0 ||
                  itemSelected[index].length == order.packages.length)
            "
            @click="removePackage(order, index)"
            >削除Package</v-btn
          >
        </v-card-title>
        <v-data-table
          :headers="splitHeaders"
          :items="order.packages == null ? [] : order.packages"
          :rows-per-page-items="[10]"
          class="inline-edit"
          item-key="key"
          select-all
          v-model="itemSelected[index]"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox
                hide-details
                primary
                v-model="props.selected"
              ></v-checkbox>
            </td>
            <td>{{ props.item.partnerName }}</td>
            <td>{{ props.item.invoiceNo }}</td>
            <td>{{ props.item.skuCode }}</td>
            <td>
              <v-text-field single-line v-model="props.item.flag" />
            </td>
            <td>
              <v-text-field
                @change="calculateTotalQty(props.item)"
                single-line
                v-model.number="props.item.cartonStartNo"
              />
            </td>
            <td>
              <v-text-field
                @change="calculateTotalQty(props.item)"
                single-line
                v-model.number="props.item.cartonEndNo"
              />
            </td>
            <td>{{ props.item.perCartonQty }}</td>
            <td>{{ props.item.totalQty }}</td>
            <td>{{ props.item.totalNetWeight }}</td>
            <td>{{ props.item.totalGrossWeight }}</td>
            <td>{{ props.item.totalVolume }}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
    <message-alert ref="message"></message-alert>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      sa: {},
      orders: [],
      deliveryOrder: { packages: [] },
      selected: [],
      itemSelected: {},
      saveable: false,
      headers: [
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: 'I/V NO', value: 'invoiceNo', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '識別No.', value: 'flag', sortable: false },
        { text: 'Carton Start', value: 'cartonStartNo', sortable: false },
        { text: 'Carton End', value: 'cartonEndNo', sortable: false },
        { text: '入れ数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '数量残', value: 'left', sortable: false },
        { text: 'N/W', value: 'totalNetWeight', sortable: false },
        { text: 'G/W', value: 'totalGrossWeight', sortable: false },
        { text: 'M3', value: 'totalVolume', sortable: false },

        // { text: 'コンテナNO', value: 'containerNo', sortable: false }
      ],
      splitHeaders: [
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: 'I/V NO', value: 'invoiceNo', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '識別No.', value: 'flag', sortable: false },
        { text: 'Carton Start', value: 'cartonStartNo', sortable: false },
        { text: 'Carton End', value: 'cartonEndNo', sortable: false },
        { text: '入れ数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: 'N/W', value: 'totalNetWeight', sortable: false },
        { text: 'G/W', value: 'totalGrossWeight', sortable: false },
        { text: 'M3', value: 'totalVolume', sortable: false },
        // { text: 'コンテナNO', value: 'containerNo', sortable: false }
      ],
    }
  },
  computed: {
    missContent() {
      return (
        this.orders.filter(
          (i) =>
            i.sjlWarehouseId != null &&
            i.forecastDeliveryDate != null &&
            i.packages != null &&
            i.packages.length > 0
        ).length < this.orders.length
      )
    },
    cantSave() {
      return (
        !this.sa.packages ||
        !!this.sa.packages.find((p) => this.balance(p) != 0)
      )
    },
    canSplit() {
      return (
        this.sa &&
        this.sa.packages &&
        this.sa.packages.find((p) => this.balance(p) > 0)
      )
    },
  },
  methods: {
    subTotal(item) {
      return Math.round(item.unitPrice * item.totalQty * 100) / 100
    },
    removePackage(order, index) {
      order.packages = order.packages.filter(
        (pkg) => this.itemSelected[index].indexOf(pkg) === -1
      )
      this.itemSelected[index] = []
    },
    removeDo(index) {
      var order = this.orders[index]
      if (order) {
        this.orders.splice(index, 1)
        this.itemSelected = {}
      }
    },
    leftPad(num, len) {
      return (Array(len).join(0) + num).slice(-len)
    },
    calculateTotalQty(item) {
      item.totalQty =
        item.perCartonQty * (item.cartonEndNo - item.cartonStartNo + 1)
    },
    checkCarton() {
      for (var i = 0; i < this.orders.length; i++) {
        for (var j = 0; j < this.orders[i].packages.length; j++) {
          var p = this.orders[i].packages[j]
          if (
            (p.cartonEndNo - p.cartonStartNo + 1) * p.perCartonQty !=
            p.totalQty
          ) {
            return p.invoiceNo
          }
        }
      }
    },
    numMulti(num1, num2) {
      var baseNum = 0
      try {
        baseNum += num1.toString().split('.')[1].length
      } catch (e) {}
      try {
        baseNum += num2.toString().split('.')[1].length
      } catch (e) {}
      return (
        (Number(num1.toString().replace('.', '')) *
          Number(num2.toString().replace('.', ''))) /
        Math.pow(10, baseNum)
      )
    },
    save() {
      console.log(this.checkCarton())

      var totalGrossWeight = this.sa.packages
        .map((p) => p.totalGrossWeight)
        .reduce((t, p) => t + p, 0)

      var totalNetWeight = this.sa.packages
        .map((p) => p.totalNetWeight)
        .reduce((t, p) => t + p, 0)

      var totalVolume = this.sa.packages
        .map((p) => p.totalVolume)
        .reduce((t, p) => t + p, 0)

      var totalPackageGrossWeight = 0
      var totalPackageNetWeight = 0
      var totalPackageVolume = 0

      this.orders.forEach((o, index) => {
        o.branchCode = this.leftPad(index + 1, 3)
        o.packages.forEach((p) => {
          var percent = (p.cartonEndNo - p.cartonStartNo + 1) / p.shippedCarton
          p.totalNetWeight =
            Math.floor(this.numMulti(percent * p.totalNetWeight, 100)) / 100
          totalPackageNetWeight += p.totalNetWeight

          p.totalGrossWeight =
            Math.floor(this.numMulti(percent * p.totalGrossWeight, 100)) / 100
          totalPackageGrossWeight += p.totalGrossWeight

          p.totalVolume =
            Math.floor(this.numMulti(percent * p.totalVolume, 1000)) / 1000
          totalPackageVolume += p.totalVolume
        })
      })

      var netWeightDifference =
        Math.round((totalNetWeight - totalPackageNetWeight) * 100) / 100
      var grossWeightDifference =
        Math.round((totalGrossWeight - totalPackageGrossWeight) * 100) / 100
      var volumeDifference =
        Math.round((totalVolume - totalPackageVolume) * 1000) / 1000

      console.log(netWeightDifference)
      console.log(grossWeightDifference)
      console.log(volumeDifference)

      if (netWeightDifference != 0) {
        this.orders[0].packages[0].totalNetWeight =
          Math.round(
            (this.orders[0].packages[0].totalNetWeight + netWeightDifference) *
              100
          ) / 100
      }

      if (grossWeightDifference != 0) {
        this.orders[0].packages[0].totalGrossWeight =
          Math.round(
            (this.orders[0].packages[0].totalGrossWeight +
              grossWeightDifference) *
              100
          ) / 100
      }

      if (volumeDifference != 0) {
        this.orders[0].packages[0].totalVolume =
          Math.round(
            (this.orders[0].packages[0].totalVolume + volumeDifference) * 1000
          ) / 1000
      }

      var resultGw = 0
      var resultNw = 0
      var resultM3 = 0

      this.orders.forEach((o) => {
        o.packages.forEach((p) => {
          console.log(p.totalGrossWeight)
          resultGw += p.totalGrossWeight
          console.log(p.totalVolume)
          resultM3 += p.totalVolume
          console.log(p.totalNetWeight)
          resultNw += p.totalNetWeight
        })
      })

      console.log(resultNw)
      console.log(resultGw)
      console.log(resultM3)

      if (!this.checkCarton()) {
        let splitOrders = this.orders
          .filter((o) => o.packages && o.packages.length > 0)
          .map((o) => ({
            ...this.deliveryOrder,
            packages: o.packages,
            sjlWarehouseId: o.sjlWarehouseId,
            forecastDeliveryDate: o.forecastDeliveryDate,
            branchCode: o.branchCode,
            id: null,
          }))
        this.$http
          .post(`delivery-orders/${this.$route.query.id}/split`, splitOrders)
          .then(() => {
            this.$message('', '保存が完了しました。')
            this.$router.go(-1)
          })
          .catch((reason) => {
            this.$message('', '拆分失败')
            console.log('split failed,reason:', reason)
          })
      } else {
        this.$message(
          '',
          '入数＊carton数＝数量, invoiceNo:' + this.checkCarton()
        )
      }
    },
    // save() {
    //   console.log(this.checkCarton())

    //   var totalPaidGrossWeight = this.sa.packages
    //     .filter(p => p.poNo != null)
    //     .map(p => p.totalGrossWeight)
    //     .reduce((t, p) => t + p, 0)

    //   var totalPaidNetWeight = this.sa.packages
    //     .filter(p => p.poNo != null)
    //     .map(p => p.totalNetWeight)
    //     .reduce((t, p) => t + p, 0)

    //   var totalPaidVolume = this.sa.packages
    //     .filter(p => p.poNo != null)
    //     .map(p => p.totalVolume)
    //     .reduce((t, p) => t + p, 0)

    //   var totalUnpaidGrossWeight = this.sa.packages
    //     .filter(p => p.poNo === null)
    //     .map(p => p.totalGrossWeight)
    //     .reduce((t, p) => t + p, 0)

    //   var totalUnpaidNetWeight = this.sa.packages
    //     .filter(p => p.poNo === null)
    //     .map(p => p.totalNetWeight)
    //     .reduce((t, p) => t + p, 0)

    //   var totalUnpaidVolume = this.sa.packages
    //     .filter(p => p.poNo === null)
    //     .map(p => p.totalVolume)
    //     .reduce((t, p) => t + p, 0)

    //   var totalPaidPackageGrossWeight = 0
    //   var totalPaidPackageNetWeight = 0
    //   var totalPaidPackageVolume = 0

    //   var totalUnpaidPackageGrossWeight = 0
    //   var totalUnpaidPackageNetWeight = 0
    //   var totalUnpaidPackageVolume = 0

    //   this.orders.forEach(o => {
    //     o.packages.forEach(p => {
    //       var percent = (p.cartonEndNo - p.cartonStartNo + 1) / p.shippedCarton

    //       p.totalNetWeight = Math.floor(percent * p.totalNetWeight * 100) / 100
    //       if (p.poNo === null) {
    //         totalUnpaidPackageNetWeight += p.totalNetWeight
    //       } else {
    //         totalPaidPackageNetWeight += p.totalNetWeight
    //       }

    //       p.totalGrossWeight =
    //         Math.floor(percent * p.totalGrossWeight * 100) / 100
    //       // totalPackageGrossWeight += p.totalGrossWeight

    //       if (p.poNo === null) {
    //         totalUnpaidPackageGrossWeight += p.totalGrossWeight
    //       } else {
    //         totalPaidPackageGrossWeight += p.totalGrossWeight
    //       }

    //       p.totalVolume = Math.floor(percent * p.totalVolume * 1000) / 1000
    //       // totalPackageVolume += p.totalVolume

    //       if (p.poNo === null) {
    //         totalUnpaidPackageVolume += p.totalVolume
    //       } else {
    //         totalPaidPackageVolume += p.totalVolume
    //       }
    //     })
    //   })

    //   var paidNetWeightDifference =
    //     Math.round((totalPaidNetWeight - totalPaidPackageNetWeight) * 100) / 100
    //   var unpaidNetWeightDifference =
    //     Math.round((totalUnpaidNetWeight - totalUnpaidPackageNetWeight) * 100) /
    //     100

    //   var paidGrossWeightDifference =
    //     Math.round((totalPaidGrossWeight - totalPaidPackageGrossWeight) * 100) /
    //     100
    //   var unpaidGrossWeightDifference =
    //     Math.round(
    //       (totalUnpaidGrossWeight - totalUnpaidPackageGrossWeight) * 100
    //     ) / 100

    //   var paidVolumeDifference =
    //     Math.round((totalPaidVolume - totalPaidPackageVolume) * 1000) / 1000
    //   var unpaidVolumeDifference =
    //     Math.round((totalUnpaidVolume - totalUnpaidPackageVolume) * 1000) / 1000

    //   console.log(netWeightDifference)
    //   console.log(grossWeightDifference)
    //   console.log(volumeDifference)

    //   if (paidNetWeightDifference != 0) {
    //     this.orders[0].packages[0].totalNetWeight =
    //       Math.round(
    //         (this.orders[0].packages[0].totalNetWeight + netWeightDifference) *
    //           100
    //       ) / 100
    //   }

    //   if (grossWeightDifference != 0) {
    //     this.orders[0].packages[0].totalGrossWeight =
    //       Math.round(
    //         (this.orders[0].packages[0].totalGrossWeight +
    //           grossWeightDifference) *
    //           100
    //       ) / 100
    //   }

    //   if (volumeDifference != 0) {
    //     this.orders[0].packages[0].totalVolume =
    //       Math.round(
    //         (this.orders[0].packages[0].totalVolume + volumeDifference) * 1000
    //       ) / 1000
    //   }

    //   var resultGw = 0
    //   var resultNw = 0
    //   var resultM3 = 0

    //   this.orders.forEach(o => {
    //     o.packages.forEach(p => {
    //       console.log(p.totalGrossWeight)
    //       resultGw += p.totalGrossWeight
    //       console.log(p.totalVolume)
    //       resultM3 += p.totalVolume
    //       console.log(p.totalNetWeight)
    //       resultNw += p.totalNetWeight
    //     })
    //   })

    //   console.log(resultNw)
    //   console.log(resultGw)
    //   console.log(resultM3)

    //   if (!this.checkCarton()) {
    //     let splitOrders = this.orders
    //       .filter(o => o.packages && o.packages.length > 0)
    //       .map(o => ({
    //         ...this.deliveryOrder,
    //         packages: o.packages,
    //         sjlWarehouseId: o.sjlWarehouseId,
    //         forecastDeliveryDate: o.forecastDeliveryDate,
    //         branchCode: o.branchCode,
    //         id: null
    //       }))
    //     this.$http
    //       .post(`delivery-orders/${this.$route.query.id}/split`, splitOrders)
    //       .then(() => {
    //         this.$message('', '保存が完了しました。')
    //         this.$router.go(-1)
    //       })
    //       .catch(reason => {
    //         this.$message('', '拆分失败')
    //         console.log('split failed,reason:', reason)
    //       })
    //   } else {
    //     this.$message(
    //       '',
    //       '入数＊carton数＝数量, invoiceNo:' + this.checkCarton()
    //     )
    //   }
    // },
    qtyRules(item) {
      for (var i = 0; i < this.selected.length; i++) {
        if (this.balance(this.selected[i]) < 0) {
          item.totalQty = this.selected[i].totalQty
        }
      }
    },
    getCartonStartNo(pkg) {
      if (this.orders && this.orders.length > 0) {
        return this.getCartonEndNo(pkg) + 1
      } else {
        return pkg.cartonStartNo
      }
    },
    getCartonEndNo(pkg) {
      if (this.orders && this.orders.length > 0) {
        var max = 0
        this.orders.forEach((o) => {
          o.packages
            .filter((p) => p.seq === pkg.seq)
            .forEach((p) => {
              max = Math.max(p.cartonEndNo, max)
            })
        })
        return max
      } else {
        return pkg.cartonEndNo
      }
    },
    split() {
      if (this.selected.length == 0) {
        this.$message('', '少なくとも1つの項目を選んでください')
      } else {
        var temp = [
          ...this.selected
            .filter((s) => this.balance(s) > 0)
            .map((s, index) => ({
              ...s,
              key: new Date().getTime() + index,
              seq: s.seq,
              partnerName: this.sa.partnerName,
              totalQty: this.balance(s),
              // cartonStartNo: this.getCartonStartNo(s)
            })),
        ]
        this.orders.push({
          packages: temp,
        })
        this.selected = []
      }
    },
    load() {
      this.$http
        .get(`shipping-advices/mother-do/${this.$route.query.id}`)
        .then((res) => {
          this.sa = res.data
          this.sa.packages.forEach((p, index) => {
            p.partnerName = this.sa.partnerName
            p.seq = new Date().getTime() + index * 1000
          })
        })
        .then(
          this.$http
            .get(`delivery-orders/${this.sa.doShipmentId}`)
            .then((res) => {
              this.orders = res.data.content
              console.log(this.orders)
              this.deliveryOrder = this.orders.find(
                (p) => p.branchCode === '999'
              )
              this.deliveryOrder.packages.forEach((p) => {
                p.partnerName = this.sa.partnerName
              })

              this.orders = []
              // this.orders = this.orders.filter(p => p.branchCode !== '999')
              // this.orders.forEach(o => {
              //   o.packages = [
              //     ...o.packages,
              //     ...this.selected.map((s, index) => ({
              //       ...s,
              //       seq: new Date().getTime() + index,
              //       partnerName: this.sa.partnerName,
              //       totalQty: this.balance(s)
              //     }))
              //   ]
              //   o.packages.forEach((p, index) => {
              //     p.partnerName = o.partnerName
              //     p.key = p.id || new Date().getTime() + index
              //   })
              // })

              // this.orders = this.orders.sort((left, right) =>
              //   left.doNo.localeCompare(right.doNo)
              // )

              // this.orders.forEach((p, index) => {
              //   this.itemSelected[index] = []
              // })
            })
        )
    },
    total(order, saPackageSeq) {
      return order.packages
        .filter((p) => p.seq === saPackageSeq)
        .reduce((t, p) => t + p.totalQty, 0)
    },
    balance(saPackage) {
      if (saPackage != null) {
        let q = this.orders.reduce(
          (t, o) => t + this.total(o, saPackage.seq),
          0
        )
        return saPackage.totalQty - q
      }
    },
    back() {
      this.$router.go(-1)
    },
    doNoNull(order) {
      return order.doNo == null ? true : false
    },
    branchCodeNull(order) {
      return order.branchCode == null ? true : false
    },
    setBranchCode(order, index) {
      return (order.branchCode = '00' + (index + 1))
    },
  },
  mounted() {
    this.load()
  },
  watch: {},
}
</script>

<style scoped>
.v-datatable .v-text-field,
.v-datatable .v-select {
  padding-top: 0px !important;
}
.v-datatable td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.v-input /deep/ .v-messages {
  min-height: 0px !important;
}
</style>
